import * as React from 'react';
import { FieldError, useController } from 'react-hook-form';
import ReactSelect, { GroupTypeBase, Styles } from 'react-select';
// styles
import cn from 'classnames/bind';
import styles from './field.module.css';
// assets

const cx = cn.bind(styles);

export interface Option {
  label: string;
  value: string;
}

export interface ISelectFieldProps {
  name: string;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
  options: Option[];
  control?: any;
  autocomplete?: boolean;
  icon?: React.ReactElement | 'mail';
  validate?: (options: Option[]) => string;
  customStyles?: Partial<Styles<any, false, GroupTypeBase<any>>>;
  colorMode?: 'light' | 'dark' | 'white';
  containerClassName?: string;
  error?: FieldError;
}

function SelectField({
  disabled,
  name,
  label,
  icon,
  options,
  control,
  placeholder,
  colorMode = 'light',
  customStyles,
  containerClassName,
  error,
  ...rest
}: ISelectFieldProps) {
  const { field } = useController({ name, control });

  return (
    <div className={cx('container', colorMode, containerClassName, { error })}>
      {label && (
        <label htmlFor={name} className={styles.label}>
          {label}
        </label>
      )}
      <div className={styles.fieldWrapper}>
        <ReactSelect
          {...rest}
          {...field}
          placeholder={placeholder}
          isSearchable={true}
          isClearable={true}
          closeMenuOnSelect={true}
          onBlur={(event) => event.preventDefault()}
          options={[...options, { value: 'Other', label: 'Other' }]}
          className={styles.select}
          classNamePrefix={'select'}
          styles={customStyles}
        />
      </div>
      <div className={cx('errorText', { visible: !!error?.message })}>{error?.message}</div>
    </div>
  );
}

export default SelectField;
